import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsPrintSchoolOptionsInfoParm } from "./wsPrintSchoolOptionsInfoParm";
import { wsPrintQueueInsertParm } from "./wsPrintQueueInsertParm";
import { wsPrintQueueDeleteParm } from "./wsPrintQueueDeleteParm";
import { wsPrintQueueCancelParm } from "./wsPrintQueueCancelParm";
import { wsPrintQueueSetPrinterParm } from "../shared/wsPrintQueueSetPrinterParm";
import { wsPrintQueueSetCardParm } from "../shared/wsPrintQueueSetCardParm";
import { wsPrintQueueSetFeeParm } from "../shared/wsPrintQueueSetFeeParm";
import { wsPrintQueuePrintParm } from "../shared/wsPrintQueuePrintParm";

@Injectable()
export class DataService_idprint {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrintQueueSelectList";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintSchoolOptionsGet
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintSchoolOptionsGet(parms: wsPrintSchoolOptionsInfoParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrintSchoolOptionsGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueInsert
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueInsert(parms: wsPrintQueueInsertParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrintQueueInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueDelete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueDelete(parms: wsPrintQueueDeleteParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrintQueueDelete";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueCancel
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueCancel(parms: wsPrintQueueCancelParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrintQueueCancel";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueSetPrinter
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueSetPrinter(parms: wsPrintQueueSetPrinterParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrintQueueSetPrinter";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueSetCard
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueSetCard(parms: wsPrintQueueSetCardParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrintQueueSetCard";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueSetFee
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueSetFee(parms: wsPrintQueueSetFeeParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrintQueueSetFee";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueSelectReleasedBySchool
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueSelectReleasedBySchool(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrintQueueSelectReleasedBySchool";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueuePrint
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueuePrint(parms: wsPrintQueuePrintParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrintQueuePrint";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
